import React from 'react';
import {TextContent} from './TextContent';
import {HtmlContent} from './HtmlContent';
import {Typography} from '@/components/ui/typography';


type ContentSectionProps = {
    className?: string;
    content?: string;
    htmlContent?: boolean;
    id?: string;
    media?: React.ReactNode;
    title?: string;
}
const ContentSection = (props: ContentSectionProps) => {
    const {content, htmlContent, id, media, title} = props;

    return (
        <div className="my-8 flex flex-col gap-2" id={id}>
            {title && (
                <Typography variant="h3">
                    {title}
                </Typography>
            )}
            {content && (
                <div>
                    {
                        htmlContent ? (
                            <HtmlContent content={content} className="prose" />
                        ) : (
                            <TextContent content={content} className="prose" />
                        )
                    }
                </div>
            )}
            {media && (
                <div className="my-4">
                    {media}
                </div>
            )}
        </div>
    )
};

export default ContentSection;
